import { useState, useRef, useEffect } from 'react';
import { Select, ProTableOt, useProTableOt, setParamsFilter, Row, Col, Button, Popconfirm, Form, message, MainModal, Input, Switch, Typography } from './../../ui/ot'
import { useMenu } from './../controller/menu_controller'
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs'
import { createContext } from 'react';
import { useContext } from 'react';
import { useLanguageCulture } from './../controller/language_controller'
import { useNavigate } from 'react-router-dom';
import { text } from '@fortawesome/fontawesome-svg-core';

const LanguageContext = createContext(null)

const MenuTable = ({
    prefixTitle = "",
    keyPrefix = 'officialweb.admin.menuSetting',
    onSelectChange = () => { },
    self = false,
    ...props
}) => {
    const navigate = useNavigate()
    const { t } = useTranslation('translation', { keyPrefix })
    const columns = [
        {
            title: t('menu_name'),
            key: "name_language_data",
            dataIndex: "name_language_data",
            align: "center",
            render: (text, record, index) =>
                (record?.name_language_data || [])?.find(
                    (tmp) => tmp?.language_culture_code === "zh-tw"
                )?.language_culture_value || "-",
        },
        // {
        //     title: "頁面分類",
        //     key: "blog_type_id",
        //     dataIndex: "blog_type_id",
        //     align: "center",
        // },
        {
            title: t('count_permission'),
            key: "menu_permission_data",
            dataIndex: "menu_permission_data",
            align: "center",
            disabled: true,
            render: (text, record, index) => {
                const count_permission = record?.menu_permission_data?.length || 0
                return <>{count_permission}</>
            },
        },
        {
            title: t('major'),
            key: "major",
            dataIndex: "major",
            align: "center",
            disabled: true,
            render: (text, record, index) => {
                const major = record?.major === 1 ? '★' : ''
                return <>{major}</>
            },
        },
        {
            title: t('action'),
            valueType: "option",
            key: "option",
            fixed: "right",
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (
                    <Row wrap={false} gutter={[4, 4]}>
                        <Col>
                            <Button
                                type="primary"
                                size="small"
                                style={{ backgroundColor: 'rgb(46, 56, 64)' }}
                                onClick={(e) => {
                                    window.open('/officialweb/admin/routeSetting' + (self ? 'Self' : '') + '?' + (new URLSearchParams({ menu_id: record?.menu_id }).toString()))
                                }}
                            >
                                {t('route_setting')}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                size="small"
                                onClick={(e) => {
                                    handleEditRow(record)
                                }}
                            >
                                {t('patch')}
                            </Button>
                        </Col>
                        <Col>
                            <Popconfirm
                                title="刪除項目"
                                description="確定刪除勾選項目?"
                                onConfirm={() =>
                                    handleDeleteRow(record?.menu_id)
                                }
                                onCancel={() => { }}
                            >
                                <Button size="small" type="danger">
                                    {t('delete')}
                                </Button>
                            </Popconfirm>
                        </Col>
                    </Row>
                );
            },
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [form] = Form.useForm();

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.menu_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.menu_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record.menu_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.menu_id
                );
                selectRow = selectRow.filter(
                    (row) => row.menu_id !== record.menu_id
                );
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [axiosMode, setAxiosMode] = useState("get");
    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);

        form.resetFields();
        form.setFieldsValue({
            ...record,
        });
        form.setValue("major", `${record?.major}`)
    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    menu_id: id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    menu_id: val?.menu_id,
                };
            });
        }
        if (data.length > 0) {
            deleteMenuData(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {

        let newValues = { ...values };
        if (axiosMode === "post") {
            postMenuData([newValues]);
        } else if (axiosMode === "patch") {
            patchMenuData([values]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }

        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }

        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };

    const {
        MenuData,
        getMenuData,
        deleteMenuData,
        postMenuData,
        patchMenuData
    } = useMenu({
        onBefore,
        onFinish
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        checkAll();
        document.title = `${prefixTitle} | 選單分類設定`;

    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo]);

    return (
        <>
            <LanguageContext.Provider value={keyPrefix}>
                <MainModal
                    axiosMode={axiosMode}
                    propsOpen={modalOpen}
                    propsSetOpen={setModalOpen}

                    propsForm={form}

                    propsLoading={modalLoading}
                    propsSetLoading={setModalLoading}

                    onFinish={onFormFinish}
                    formElement={<MenuForm />}
                />
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                        <Typography.Title
                            level={3}
                        >
                            {t('')}
                        </Typography.Title>
                        <ProTableOt
                            actionRef={actionRef}
                            columns={columns}
                            check={check}
                            setCheck={setCheck}
                            rowKey={"menu_id"}
                            selections={
                                {
                                    // onChange: (index_, data_) => set_data(data_)
                                }
                            }
                            toolBarRender={() => [
                                <Button
                                    type="primary"
                                    style={{
                                        color: "#000",
                                        backgroundColor: "#ffedee",
                                    }}
                                    onClick={(e) => handleAddRow()}
                                >
                                    {t('post_menu')}
                                </Button>,
                                <Popconfirm
                                    title="刪除項目"
                                    description="確定刪除勾選的項目?"
                                    onConfirm={() => handleDeleteRow()}
                                    onCancel={() => { }}
                                >
                                    <Button
                                        type="primary"
                                        style={{
                                            color: "#000",
                                            backgroundColor: "#ffedee",
                                        }}
                                    >
                                        {t('delete_menu')}
                                    </Button>
                                </Popconfirm>,
                            ]}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={false}
                            request={async (params = {}, sort, filter) => {
                                setAxiosMode("get");
                                let newParams = {};
                                let order = setOrders(sort);
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params?.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key,
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                setPageSize(params?.pageSize ?? 20);

                                return getMenuData(newParams);
                                // return []
                            }}
                            pageSize={pageSize}
                            rowSelection={{
                                type: "checkbox",
                                selectedRowKeys: selectedRowKeys,
                                ...rowSelection,
                            }}
                            tableAlertOptionRender={() => {
                                return (
                                    <>
                                        {/* <Typography.Link>匯出資料</Typography.Link> */}
                                    </>
                                );
                            }}
                            tableAlertRender={({
                                selectedRowKeys,
                                selectedRows,
                                // onCleanSelected,
                            }) => {
                                return (
                                    <span>
                                        已選擇 {selectedRowKeys.length} 項
                                        <a
                                            style={{ marginInlineStart: 8 }}
                                            onClick={onCleanSelected}
                                        >
                                            取消選擇
                                        </a>
                                    </span>
                                );
                            }}
                            scroll={{
                                x: "100%",
                            }}
                        />
                    </Col>
                </Row>
            </LanguageContext.Provider>
        </>
    );
};
export default MenuTable

const MenuForm = ({
    keyPrefix = 'officialweb.admin.menuSetting',
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    ...props
}) => {
    const [form] = Form.useForm();
    const keyPrefix_ = useContext(LanguageContext);
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getLanguageCultureData()
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = (values, { name, type }) => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5)
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });
    const {
        LanguageCultureData,
        getLanguageCultureData
    } = useLanguageCulture({})
    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"menu_id"}
                            >
                                <div />
                            </Form.Item>
                            {/* <Form.List
                                name={'property_json'}
                                hidden={true}
                            >
                                {fields => <></>}
                            </Form.List> */}
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label={t('major')}
                                name={"major"}
                            >
                                <Switch

                                    checkedChildren={t('yes')}
                                    unCheckedChildren={t('no')}
                                    mode="number"

                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.List
                                name={'menu_permission_data'}
                            >
                                {fields => <></>}
                            </Form.List>
                            <Form.List
                                name={'name_language_data'}
                            >
                                {(fields, { add, remove }) => <>
                                    <Row gutter={[16, 16]} justify={'end'}>
                                        <Col>
                                            <Button
                                                onClick={() => add()}
                                            >{t('post_language_manage')}</Button>
                                        </Col>
                                        <Col span={24}>
                                            {fields.map((field, index) => <>
                                                <Row gutter={[8, 8]} key={field.id} style={{ padding: '1rem' }}>
                                                    <Form.Item
                                                        name={[field.name, "language_manage_id"]}
                                                        hidden={true}
                                                    >
                                                    </Form.Item>
                                                    <Col span={24}>
                                                        <Form.Item
                                                            label={t('language_culture')}
                                                            name={[field.name, "language_culture_code"]}
                                                        >
                                                            <Select
                                                                options={LanguageCultureData.map(item => (
                                                                    {
                                                                        label: item?.language_culture_name,
                                                                        value: item?.language_culture_code,
                                                                    }
                                                                ))}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Form.Item
                                                            label={t('menu_name')}
                                                            name={[field.name, "language_culture_value"]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={24}
                                                        style={{
                                                            textAlign: 'right'
                                                        }}>
                                                        <Button
                                                            onClick={() => remove(index)}
                                                        >{t('delete')}</Button>
                                                    </Col>
                                                </Row>
                                            </>)}
                                        </Col>
                                    </Row>
                                </>}
                            </Form.List>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}